import style from '../style/components/header.module.scss'

interface HeaderProps {
  classes?: string
  left?: React.ReactNode
  right?: React.ReactNode
}
const Header = ({ left, right, classes }: HeaderProps) => {
  return (
    <header className={[classes, style.header].join(' ')}>
      {left}
      {right}
    </header>
  )
}

export default Header
